<template>
  <div>
    <div v-show="participants.length" class="table-container" style="width:60%;max-height:525px;">
      <table>
        <thead>
        <tr>
          <th colspan="4">
            <div>
              <div style="float:left;">
                <span>participating dairies</span>
              </div>
              <div style="float:right;">
                <tooltip-information text="new dairy"
                                     type="point-right">
                  <font-awesome-icon icon="building"
                                     class="control-icon-style"
                                     v-on:click="openConfiguration({}, true)"/>
                </tooltip-information>
              </div>
            </div>
          </th>
        </tr>
        </thead>
        <tbody v-for="participant in participants" :key="participant.dairy.id">
        <tr>
          <td class="control-icon-style"
              v-on:click="openAccountsList(participant)">
            <tooltip-information text="accounts"
                                 type="point-left">
              <font-awesome-icon :icon="participant === selectedParticipant ? 'caret-down' : 'caret-right'"
                                 style="font-size:20pt"/>
            </tooltip-information>
          </td>
          <td>
            <div style="float:left;">
              <div>
                <span style="padding-left:2%;"><sup>[<b>{{ participant.dairy.id }}</b>]</sup>&nbsp;{{
                    participant.contact.name.trim()
                  }}</span>
              </div>
              <div>
                <span style="padding-left:2%;">
                  {{ participant.contact.street.trim() }}, {{ participant.contact.address.trim() }}
                </span>
              </div>
            </div>
          </td>
          <td class="control-icon-style">
            <tooltip-information text="admins"
                                 type="point-down">
              <font-awesome-icon icon="user-shield"
                                 v-on:click="openAdministratorList(participant)"/>
            </tooltip-information>
          </td>
          <td class="control-icon-style">
            <tooltip-information text="config"
                                 type="point-down">
              <font-awesome-icon icon="cogs"
                                 v-on:click="openConfiguration(participant, false)"/>
            </tooltip-information>
          </td>
        </tr>
        <tr>
          <td v-if="displayAccount && participant===selectedParticipant"
              colspan="4">
            <account :username="username"
                     :role="role"
                     :participant="participant"
                     @apierror="setApiError"
                     @apierrortext="setApiErrorText"></account>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <administrator v-if="displayAdministrator"
                   :participant="selectedParticipant"
                   @apierror="setApiError"
                   @apierrortext="setApiErrorText"
                   @close="closeAdministratorList"></administrator>
    <configuration v-if="displayConfiguration"
                   :participant="selectedParticipant"
                   :isNew="newConfiguration"
                   @apierror="setApiError"
                   @apierrortext="setApiErrorText"
                   @close="closeConfiguration"></configuration>
  </div>
</template>

<script>
import TooltipInformation from '@/components/tooltip/TooltipInformation'
import Configuration from '@/components/control/dairy/configuration/Configuration'
import Administrator from '@/components/control/dairy/administrator/Administrator'
import Account from '@/components/control/dairy/account/Account'

export default {
  name: 'List',
  components: {
    TooltipInformation,
    Configuration,
    Administrator,
    Account,
  },
  props: ['username', 'role'],
  emits: ['apierror', 'apierrortext'],
  data: function () {
    return {
      participants: [],
      selectedParticipant: {},
      newConfiguration: false,
      displayConfiguration: false,
      displayAdministrator: false,
      displayAccount: false,
    }
  },
  methods: {
    listDairies() {
      this.axios
          .get("control/dairy/list")
          .then(response => {
            this.participants = _.orderBy(response.data, ['dairy.id'], ['asc'])
          })
          .catch(error => {
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    openConfiguration(participant, isNew) {
      this.selectedParticipant = participant
      this.newConfiguration = isNew
      this.displayConfiguration = true
    },
    closeConfiguration() {
      this.displayConfiguration = false
      this.listDairies()
    },
    openAdministratorList: function (participant) {
      this.selectedParticipant = participant
      this.displayAdministrator = true
    },
    closeAdministratorList() {
      this.displayAdministrator = false
      this.listDairies()
    },
    openAccountsList(participant) {
      if (participant === this.selectedParticipant) {
        this.displayAccount = false
        this.selectedParticipant = {}
      } else {
        this.displayAccount = true
        this.selectedParticipant = participant
      }
    },
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    },
  },
  created() {
    this.listDairies()
  },
}
</script>